<template>
  <div class="pages-wrapper" id="projectTemplatePageWrapper">
    <section class="project-pages" :gutter="20">
      <button class="page-control circled-arrow-left" @click="handleMoveCarousel(-1)" :disabled="!controlArrows.scrollLeft"></button>
      <!-- Pages -->
      <div id="projectTemplatePagePreview" ref="projectTemplatePagePreview" :class="['project-pages-col', ((customResolution.custom) ? `custom-res ${customResolution.customOrientation}`: projectOrientation)]">
        <draggable
          v-bind="sortDraggableOptions"
          v-model="pages"
          draggable=".page-item"
          id="projectTemplatePageSortWrapper"
          tag="span"
          :class="[{'sort-active': pagesSortActive }, 'transition-group-container']"
          :item-key="(element) => element?._edit?.sortKeyWithIndx"
          :component-data="{name:'flip-list'}"
          :forceFallback="true"
          @start="handlePageIconSortStart"
          @end="handlePageIconSortEnd">
          <template #item="{ element: page, index: indx }">
            <div
              :class="[page.settings?.overlay ? 'is-overlay' : 'page-item', {'locked-by-user-tags': page._edit.lockedByUserTags}]">
              <div class="item-wrapper" :style="customResolution.ui.wrapperStyle">
                <div :class="['pp-item', { 'is-selected': (currentPageNumber === indx), 'with-action': pages.length > 1, 'hovered': hoveredPage === indx, 'custom-resolution': customResolution.custom}]" :style="customResolution.ui.elStyle">
                  <div class="page-preview">
                    <div class="media-preview-fixed">
                      <loader v-if="sendingMessageToSVG" :isRequesting="true" :xs="true" :backgroundNoOpacity="true" :textLabel="''"></loader>
                      <iframe :id="`projectPagePreview_${indx}`"
                        :src="$utils.filterMediaPreviewUrl(`${projectTemplate.preview.url}`, { queryParams: { pagePreviewNumber: indx } })"
                        :data-src="$utils.trimDataSrc(`${projectTemplate.preview.url}&pagePreviewNumber=${indx}`)"
                        @load="handleSVGOnLoad()"
                        :style="customResolution.ui.elStyle"
                        allow="clipboard-read *; clipboard-write *;"
                        :class="['project-page-preview', 'template-target-on-refresh-token', 'content-loaded', `media-preview-page-${indx}`, {}]">
                      </iframe>
                    </div>
                  </div>

                  <div :class="['page-num page-number-cover', indx]"
                    @click="handleProjectPageClick(indx)"
                    @mouseover="hoveredPage = indx"
                    @mouseout="hoveredPage = null"
                    :style="customResolution.ui.elStyle">
                  </div>

                  <div v-if="pages.length > 1 && deletePageIconVisible"
                    @click="handleProjectPageDeleteClick(indx)"
                    @mouseover="hoveredPage = indx"
                    @mouseout="hoveredPage = null" class="delete-icon">
                  </div>

                  <div
                    v-if="pages.length >= 1 && !page.settings?.overlay && !isUserLimited"
                    class="item-duration"
                    @mouseover="hoveredPage = indx"
                    @mouseout="hoveredPage = null">
                    <duration-input
                      data-component-element-id="project-template-preview-duration-input"
                      :model-value="handleDurationFormatting(page?.settings?.dur)"
                      @blur="handleFocusOut($event, indx)"
                      @update:model-value="handleChangeDuration($event, indx)"
                    />
                  </div>
                </div>

                <div class="item-tags">
                  <div class="item-tags-wrapper">
                    <el-tooltip
                      v-for="(tag, tIndex) in filterOutByUserRights(page.uid, page.tags)" :key="tIndex"
                      :popper-class="`custom-tooltip-popper-tag tag-tooltip bg-${tag.backgroundColor}}`"
                      :show-arrow="false"
                      effect="light"
                      placement="bottom">
                        <template #content>
                          <div id="tooltip-content" :style="{backgroundColor: tag.backgroundColor}">{{ tag.value }}</div>
                        </template>
                        <template #default>
                          <span class="item-tag" :style="{backgroundColor: tag.backgroundColor}"></span>
                        </template>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="overlay-divider"></div>
            </div>
          </template>
        </draggable>
      </div>
      <button class="page-control circled-arrow-right" @click="handleMoveCarousel(+1)" :disabled="!controlArrows.scrollRight"></button>
    </section>
  </div>
</template>

<script src="./project-template-pages.js"></script>
<style lang="scss" src="./project-template-pages.scss"></style>
